import React from 'react';

function List({ documentdata, documentName }) {
  const getIcon = (url) => {
    if (String(url).includes('drive.google.com')) {
      return (
        <img width="16" height="16" src="https://upload.wikimedia.org/wikipedia/commons/d/da/Google_Drive_logo.png" alt="drive" />
      );
    }
    if (String(url).includes('youtube.com')) {
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="#FF0000">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      );
    }
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
    );
  };

  return (
    <div className="paper-section">
      <div className="section-header">{documentName}</div>
      <ul className="section-list">
        {documentdata.length === 0 ? (
          <li className="section-empty">No resources available</li>
        ) : (
          documentdata.map((entry, i) => (
            entry.column1 && entry.column2 ? (
              <li className="section-item" key={i}>
                <div className="item-icon">{getIcon(entry.column2)}</div>
                <a href={entry.column2} target="_blank" rel="noreferrer">
                  {entry.column1}
                </a>
              </li>
            ) : null
          ))
        )}
      </ul>
    </div>
  );
}

export default List;
